import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, type ButtonProps } from '@mui/material';
import { FileCopyOutlined } from '@mui/icons-material';

export const DuplicateButton: FC<ButtonProps> = ({ children, ...props }) => {
  const { t } = useTranslation();

  return (
    <Button variant="outlined" startIcon={<FileCopyOutlined />} {...props}>
      {children ?? t('Dublicate')}
    </Button>
  );
};
